import { Action, State, StateContext } from '@ngxs/store';

import { BillingInfo } from './billing-info.model';
import * as DesignationActions from './billing-info.actions';

@State<BillingInfo>({
  name: 'billingInfo',
  defaults: new BillingInfo()
})
export class BillingInfoState {
  @Action(DesignationActions.AddBillingInfo)
  addInfoItem(
    { getState, setState }: StateContext<BillingInfo>,
    { payload }: DesignationActions.AddBillingInfo
  ) {
    const state = getState();
    setState({ ...state, [payload.key]: payload.value });
  }

  @Action(DesignationActions.UpdateBillingInfo)
  updateInfo(
    { getState, setState }: StateContext<BillingInfo>,
    { payload }: DesignationActions.UpdateBillingInfo
  ) {
    const state = getState();
    // Filter out undefined/null values so partial updates (e.g. from Google Pay)
    // don't overwrite fields the user already filled in
    const definedValues = {};
    for (const key of Object.keys(payload)) {
      if (payload[key] != null) {
        definedValues[key] = payload[key];
      }
    }
    setState({ ...state, ...definedValues });
  }
}
